export const MULTIPLE_SPACES_REGEX = /  +/g;
export const EMPTY_SPACES_REGEX = /\s/g;
export const EVERYTHING_AFTER_PLUS = /\+.*/;
